// DO NOT EDIT! This file is generated automaticaly with 'npm run generate-stimulus'

import * as Turbo from "@hotwired/turbo";
import { Application } from "stimulus";
const application = Application.start();

import { default as AutoscrollingImages } from "./../back/jdd-components/autoscrolling-images/autoscrolling-images.stimulus.js";
application.register("autoscrolling-images", AutoscrollingImages);

import { default as BeforeAfterPhotos } from "./../back/jdd-components/before-after-photos/before-after-photos.stimulus.js";
application.register("before-after-photos", BeforeAfterPhotos);

import { default as ListOfOpinions } from "./../back/jdd-components/list-of-opinions/list-of-opinions.stimulus.js";
application.register("list-of-opinions", ListOfOpinions);

import { default as MapWithPins } from "./../back/jdd-components/map-with-pins/map-with-pins.stimulus.js";
application.register("map-with-pins", MapWithPins);

import { default as LocalSearchHistory } from "./../back/local-search-history.stimulus.js";
application.register("local-search-history", LocalSearchHistory);

import { default as Banner } from "./../back/routes/common/bannerTopBottom/banner.stimulus.js";
application.register("banner", Banner);

import { default as FilterClear } from "./../back/routes/common/filters/filter-clear.stimulus.js";
application.register("filter-clear", FilterClear);

import { default as FilterCount } from "./../back/routes/common/filters/filter-count.stimulus.js";
application.register("filter-count", FilterCount);

import { default as FilterGreyOut } from "./../back/routes/common/filters/filter-grey-out.stimulus.js";
application.register("filter-grey-out", FilterGreyOut);

import { default as MobileFilters } from "./../back/routes/common/filters/mobile-filters.stimulus.js";
application.register("mobile-filters", MobileFilters);

import { default as HorizontalScroller } from "./../back/routes/common/horizontal-scroller/horizontal-scroller.stimulus.js";
application.register("horizontal-scroller", HorizontalScroller);

import { default as Sortable } from "./../back/routes/common/sortable/sortable.stimulus.js";
application.register("sortable", Sortable);

import { default as PasswordStrength } from "./../back/routes/dowodzenie/password-strength.stimulus.js";
application.register("password-strength", PasswordStrength);

import { default as SearchHistory } from "./../back/routes/szukaj/search-history.stimulus.js";
application.register("search-history", SearchHistory);

import { default as AutogrowTextarea } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/autogrow-textarea.stimulus.js";
application.register("autogrow-textarea", AutogrowTextarea);

import { default as ComponentDebugger } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/component-debugger.stimulus.js";
application.register("component-debugger", ComponentDebugger);

import { default as ExportableTextarea } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/exportable-textarea.stimulus.js";
application.register("exportable-textarea", ExportableTextarea);

import { default as InputImagePreview } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/input-image-preview.stimulus.js";
application.register("input-image-preview", InputImagePreview);

import { default as JddTablePaste } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/jdd-table-paste.stimulus.js";
application.register("jdd-table-paste", JddTablePaste);

import { default as JsonEditor } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/json-editor.stimulus.js";
application.register("json-editor", JsonEditor);

import { default as MarkdownTextarea } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/markdown-textarea.stimulus.js";
application.register("markdown-textarea", MarkdownTextarea);

import { default as RefreshOnTsChanges } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/refresh-on-ts-changes.stimulus.js";
application.register("refresh-on-ts-changes", RefreshOnTsChanges);

import { default as RefreshStyles } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/refresh-styles.stimulus.js";
application.register("refresh-styles", RefreshStyles);

import { default as SubmitOnInput } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/submit-on-input.stimulus.js";
application.register("submit-on-input", SubmitOnInput);

import { default as Toast } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/toast.stimulus.js";
application.register("toast", Toast);

export { Turbo };
